import React from 'react';
import FlagIconFactory from 'react-flag-icon-css';

const AppFlagIcon = FlagIconFactory(React, { useCssModules: false });

export default AppFlagIcon;
